module.exports = __webpack_public_path__ + "img/qszf.123304c2.png";